export const APPRENTICESHIP_CONTRACT_TYPE_ID = 6;

// Core API rejects a create without an external URL, so duplicating into an external-ATS
// workspace writes this. VacancySerializer.fromJson drops it again on the way back in, so no
// read site ever sees it and the edit form presents an empty required field.
export const DUPLICATED_VACANCY_EXTERNAL_URL_PLACEHOLDER = 'https://target.example.com/apply';
